/** HybridORS Admin theme palettes */

export const THEME_STORAGE_KEY = 'hybridors-admin-theme'

export const THEMES = [
  {
    id: 'indigo',
    name: 'Indigo',
    primary: '#6366f1',
    primaryLight: '#ede9fe',
    primaryDark: '#4338ca',
    primaryHover: '#818cf8',
    sidebarFrom: '#1e1b4b',
    sidebarTo: '#312e81',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(99, 102, 241, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#ede9fe',
    headerTo: '#ffffff',
    layoutBg: '#f5f3ff'
  },
  {
    id: 'blue',
    name: 'Tech Blue',
    primary: '#1677ff',
    primaryLight: '#e8f3ff',
    primaryDark: '#0958d9',
    primaryHover: '#4096ff',
    sidebarFrom: '#0b1a33',
    sidebarTo: '#0f2844',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(22, 119, 255, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#e8f3ff',
    headerTo: '#ffffff',
    layoutBg: '#eef3fb'
  },
  {
    id: 'green',
    name: 'Health Green',
    primary: '#16a34a',
    primaryLight: '#f0fdf4',
    primaryDark: '#15803d',
    primaryHover: '#22c55e',
    sidebarFrom: '#052e16',
    sidebarTo: '#14532d',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(22, 163, 74, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#f0fdf4',
    headerTo: '#ffffff',
    layoutBg: '#f6ffed'
  },
  {
    id: 'purple',
    name: 'Deep Purple',
    primary: '#7f56d9',
    primaryLight: '#f4ebff',
    primaryDark: '#6941c6',
    primaryHover: '#9e77ed',
    sidebarFrom: '#2e1065',
    sidebarTo: '#4c1d95',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(127, 86, 217, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#f4ebff',
    headerTo: '#ffffff',
    layoutBg: '#faf5ff'
  },
  {
    id: 'orange',
    name: 'Energy Orange',
    primary: '#ea580c',
    primaryLight: '#fff7ed',
    primaryDark: '#c2410c',
    primaryHover: '#f97316',
    sidebarFrom: '#431407',
    sidebarTo: '#7c2d12',
    sidebarText: 'rgba(255, 255, 255, 0.72)',
    sidebarActiveBg: 'rgba(234, 88, 12, 0.32)',
    sidebarActiveText: '#ffffff',
    headerFrom: '#fff7ed',
    headerTo: '#ffffff',
    layoutBg: '#fff7ed'
  }
]

export const DEFAULT_THEME_ID = 'indigo'

export function getThemeById(id) {
  return THEMES.find(t => t.id === id) || THEMES[0]
}
